angular.module('satv.media')

.factory('DownloadModal', ['config', 'Modal', function(config, Modal) {
    return {
        open: function(params, data) {
            return Modal.create(
                config.templateRoot + '/media/download/modal',
                params,
                data
            );
        }
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/services/DownloadModal.js